<template>
  <div
    class="map-sidebar elevation-2"
    v-if="isVisible"
    v-resize="onResize"
  >
    <div>
      <v-system-bar
        class="no-select"
        window
        dark
        color="primary"
        status
        dark
      >
        <span>שכבות</span>
        <v-spacer></v-spacer>
        <v-icon @click="toggleSidebar">close</v-icon>
      </v-system-bar>
      <div class="map-sidebar-content noselect">
        <v-expansion-panel class="mb-0">
          <v-expansion-panel-content
            v-for="(item, index) in dataSourcesGroups"
            :key="'expanel' + index"
          >
            <template v-slot:header>
              <div>{{ item.title }} <span class="grey--text">({{ numberOfActiveDataSources(index) }}/{{ numberOfDataSources(index) }})</span></div>
              <!-- <v-btn
                  v-if="item.dataSources.length > 1"
                  flat
                  color="primary"
                  @click="selectAll(index, true)"
                >×‘×—×¨ ×”×›×œ</v-btn>
                <v-btn
                  v-if="item.dataSources.length > 1"
                  flat
                  color="primary"
                  @click="selectAll(index, false)"
                >×”×¡×¨ ×”×›×œ</v-btn> -->
            </template>
            <v-card
              class="expansion-card"
              :style="{ 'max-height': sidebarContentHeight() + '!important' }"
            >
              <v-card-actions>
                <v-btn
                  v-if="item.dataSources.length > 1"
                  flat
                  color="primary"
                  @click="selectAll(index, true)"
                >בחר הכל</v-btn>
                <v-btn
                  v-if="item.dataSources.length > 1"
                  flat
                  color="primary"
                  @click="selectAll(index, false)"
                >הסר הכל</v-btn>
              </v-card-actions>
              <v-card-text class="pt-0">
                <v-checkbox
                  color="primary"
                  hide-details
                  class="mt-0 mb-1"
                  v-for="(dataSource, index2) in item.dataSources"
                  :key="'dataSource' + index2"
                  :label="dataSource.name"
                  v-model="dataSource.isActive"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radioGroup: null
    };
  },

  computed: {
    // sidebarContentHeight() {
    //   if (this.$refs.toolbar) {
    //     let toolbarHeight = this.$refs.toolbar.$el.clientHeight;
    //     let sectionsTitlesHeight = this.dataSourcesGroups.length * toolbarHeight;
    //     let sidebarContentHeight =
    //       this.mapHeight - toolbarHeight - sectionsTitlesHeight - 10 + "px";
    //     console.log(sidebarContentHeight);
    //     return sidebarContentHeight;
    //   } else {
    //     return "100px";
    //   }
    // }
    // mapHeight2() {
    //   return this.mapHeight;
    // },
    dataSourcesGroups() {
      let dataSourcesGroups = this.$store.getters["maps/dataSourcesGroups"](this.mapId);
      let tempMap = {}
      for (let dataSourcesGroup of dataSourcesGroups) {
        if (!tempMap[dataSourcesGroup.title]) {
          tempMap[dataSourcesGroup.title] = dataSourcesGroup.dataSources
        } else {
          tempMap[dataSourcesGroup.title] = tempMap[dataSourcesGroup.title].concat(dataSourcesGroup.dataSources)
        }
      }
      let mergedDataSourcesGroups = []
      for (let key of Object.keys(tempMap)) {
        mergedDataSourcesGroups.push({
          title: key,
          dataSources: tempMap[key]
        })
      }
      return mergedDataSourcesGroups
    }
  },

  methods: {
    numberOfActiveDataSources(groupIndex) {
      if (this.dataSourcesGroups[groupIndex]) {
        let dataSources = this.dataSourcesGroups[groupIndex].dataSources;
        if (Array.isArray(dataSources)) {
          let activeDataSources = dataSources.filter(item => {
            return item.isActive;
          });
          return activeDataSources.length;
        }
      }
      return 0;
    },
    numberOfDataSources(groupIndex) {
      if (this.dataSourcesGroups[groupIndex]) {
        let dataSources = this.dataSourcesGroups[groupIndex].dataSources;
        if (Array.isArray(dataSources)) {
          return dataSources.length;
        }
      }
      return 0;
    },
    sidebarContentHeight() {
      let toolbarHeight = 50;
      let expansionPanelTitleHeight = 58;
      let sectionsTitlesHeight =
        this.dataSourcesGroups.length * expansionPanelTitleHeight;
      let sidebarContentHeight =
        this.mapHeight - sectionsTitlesHeight - toolbarHeight + "px";
      console.log(sidebarContentHeight);
      return sidebarContentHeight;
    },
    onResize() {
      // let toolbarHeight = this.$refs.toolbar.$el.clientHeight;
      // let sectionsTitlesHeight = this.dataSourcesGroups.length * toolbarHeight;
      // this.sidebarContentHeight =
      //   this.mapHeight - toolbarHeight - sectionsTitlesHeight - 10 + "px";
    },
    selectAll(index, val) {
      let dataSourcesGroup = this.dataSourcesGroups[index];
      if (dataSourcesGroup) {
        for (let dataSource of dataSourcesGroup.dataSources) {
          dataSource.isActive = val;
        }
      }
    }
  },

  watch: {},

  props: ["mapId", "isVisible", "toggleSidebar", "mapHeight"],

  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.map-sidebar {
  position: absolute;
  z-index: 7;
  background-color: transparent;
  top: 75px;
  right: 10px;
  // bottom: 40px;
  min-width: 250px;
  width: 22%;
}

.expansion-card {
  max-height: 100px;
  overflow-y: scroll;
}

.map-sidebar-content {
  background: transparent;
}
</style>

<style lang="scss">
// .map-sidebar {
//   .v-toolbar__content {
//     padding-left: 10px;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/map/MapSidebar.vue